module.exports = __webpack_public_path__ + "img/flag-pl.a9e89f3.svg";